import { CSSProperties } from 'react';
import { COLORS, DISPLAY_STRETCH, FONTS, GLASS } from '../../../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  grid: {
    ...GLASS,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    border: `1px solid ${COLORS.border}`,
    marginTop: '3rem',
  },
  claim: {
    padding: '2rem 1.75rem',
  },
  title: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: '1.6rem',
    lineHeight: 1.1,
    color: COLORS.text,
    marginBottom: '0.85rem',
  },
  body: {
    fontSize: '1rem',
    lineHeight: 1.7,
    color: COLORS.muted,
  },
};
